import type { IAugmentedJQuery, IComponentController, IScope } from "angular";

export class SearchComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "$element", "hotkeys"];

    public partnerId: string;

    public searchString: string;

    public isDisabled: boolean;

    public constructor(
        private readonly $scope: IScope,
        private readonly $element: IAugmentedJQuery,
        private readonly hotkeys: angular.hotkeys.HotkeysProvider,
    ) {}

    public $onInit(): void {
        this.hotkeys.bindTo(this.$scope).add({
            callback: (event: Event) => {
                this.$element.find("#global-search-input")[0].focus();
                event.preventDefault();
            },
            combo: ["f"],
            description: "Find",
        });
    }
}
